import TopBar from "./components/TopBar";
import Hero from "./components/Hero";
import ClipsSection from "./components/ClipsSection";
import ShotsSection from "./components/ShotsSection";
import RecordsSection from "./components/RecordsSection";
import LivesSection from "./components/LivesSection";
import MemesSection from "./components/MemesSection";
import TrendSection from "./components/TrendSection";
import TakeoutBand from "./components/TakeoutBand";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-cream text-ink">
      <TopBar />
      <main>
        <Hero />
        <ClipsSection />
        <ShotsSection />
        <RecordsSection />
        <LivesSection />
        <MemesSection />
        <TrendSection />
        <TakeoutBand />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}